import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';

type ReservationPolicyFacetProps = Readonly<{
  title: string;
  label: string;
  isChecked: boolean;
  onToggle: (event: React.ChangeEvent<HTMLInputElement>) => void;
}>;

export const ReservationPolicyFacet: React.FC<ReservationPolicyFacetProps> = ({ title, label, isChecked, onToggle }) => {
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        <StyledCheckboxV2
          isChecked={isChecked}
          onChange={onToggle}
          id="free-cancellation"
        >
          <TextV2
            typographyVariant="body1"
            color="mono14"
          >
            {label}
          </TextV2>
        </StyledCheckboxV2>
      </Flex>
    </FilterFacet>
  );
};
